import React from "react";
import Icon from "./Icon";
import styled from "styled-components";
import { Wrapper, Text, IconWrapper, Image } from "../styles";
import TrackButton from "./TrackButton";
import appConfig from "../../../../app-config";
import { DELIVERY, PICKUP } from "../../OrderSetting/orderSettingTypes";

const ButtonWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-gap: 10px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const OrderComplete = ({ orderStatus }) => {
  const isFeastifyDeliveryOrder =
    appConfig.appSource === "feastify" && orderStatus.order_type === DELIVERY;

  return (
    <Wrapper>
      <IconWrapper>
        {appConfig.orderStatusImages &&
        appConfig.orderStatusImages.order_complete ? (
          <Image src={appConfig.orderStatusImages.order_complete} />
        ) : (
          <Icon
            className={
              orderStatus.order_type === PICKUP
                ? "fas fa-store"
                : orderStatus.order_type === DELIVERY
                ? "fas fa-car-side"
                : "fas fa-shopping-bag"
            }
          />
        )}
      </IconWrapper>
      <ButtonWrapper>
        <Text id="OrderComplete-OrderReady">
          {appConfig.appSource === "madradish"
            ? "Enjoy your meal"
            : isFeastifyDeliveryOrder
            ? "You will receive delivery update via SMS"
            : `Your order is ${
                orderStatus.order_type === PICKUP ? "ready" : "out"
              } for ${
                orderStatus.order_type === "drop_off"
                  ? "drop-off"
                  : orderStatus.order_type
              }`}
        </Text>
        {orderStatus &&
          orderStatus.delivery_tracking_url &&
          !isFeastifyDeliveryOrder && (
            <TrackButton
              id="OrderComplete-TrackButton"
              orderStatus={orderStatus}
            />
          )}
      </ButtonWrapper>
    </Wrapper>
  );
};

export default OrderComplete;
